import styled from 'styled-components';
import { theme } from '@upsolve/ui';

const HintCard = styled.div`
  padding: 12px 20px;
  height: auto;
  max-height: 100%;
  line-height: 150%;
  font-size: 14px;
  border-radius: 4px;
  h4, h5 {
    color: ${theme.colors.gray['300']};
    margin-bottom 0.5em;
    border-bottom: 1px solid ${theme.colors.white['500']};
    width: 100%;
  }
  .value-props {
    p {
      margin: 0.25em 0;
    }
    div {
      width: 100%;
      margin-top: 0.5em;
      a, button {
        display: block;
        font-weight: 700;
      }
      button {
        width: 100%;
      }
    }
  }
  .lead-capture {
    margin-top: 0.5em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    label {
      color: ${theme.colors.gray['300']};
    }
    form {
      display: block;
    }
    button {
      margin: 0;
      margin-top: 0.5em;
    }
    small {
      width: 100%;
      text-align: center;
    }
  }
  a:hover {
    cursor: pointer;
  }
  p > a {
    color: ${theme.colors.brand['500']};
  }
  small > a {
    text-decoration: underline;
  }
  .lead-capture__form__error {
    margin: 0.5em 0 0;
    padding: 0.25em 1.5em;
    border-radius: 0.25em;
    background: ${theme.colors.red['500']};
    color: white;
  }
  .lead-capture__form__success {
    margin: 0.5em 0 0;
    padding: 0.75em 1.5em;
    border-radius: 0.25em;
    background: ${theme.colors.green['300']};
    color: white;
  }
  @media (max-width: 45em) {
    overflow: scroll;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export default HintCard;
